import { Redirect } from 'react-router';
import { useHistory, useParams } from 'react-router-dom';

import { IonButton, IonContent, IonPage } from '@ionic/react';

import { observer } from 'mobx-react-lite';
import RunPage from '.';
import VStack from '../../components/VStack';
import { useStores } from '../../models';
import Trans from 'util/Trans';
import { Record } from 'spinnaxBase/logic/model';

// TODO: distinguish between own and friend tricks
const RunDetailTab: React.FC = observer(() => {
  const store = useStores();
  const history = useHistory();
  const params = useParams<{ id: string }>();

  const record = store.recordList.findRun(params.id);

  const navigateToDetailPage = () => {
    history.goBack();
  };

  if (record != null) {
    return <RunPage record={record} />;
  } else {
    // Redirect to /record in case the trick isn't found
    return <Redirect to="/record" />;
  }
  // return (
  //   <IonPage className="notchSafe">
  //     <IonContent>
  //       <VStack>
  //         <Trans
  //           i18nKey="TRICK_NOT_AVAILABLE"
  //           values={{ trick: params.id }}
  //         />
  //         <IonButton onClick={navigateToDetailPage}>
  //           <Trans i18nKey="BACK_TO_LIST">Zurück zur Liste</Trans>
  //         </IonButton>
  //       </VStack>
  //     </IonContent>
  //   </IonPage>
  // );
});

export default RunDetailTab;
